import { PRIVATE_EVENT_ADD_ONS, type PrivateEventCrewView } from '../../api/privateEvents';
import { useViewport } from '../../hooks/useViewport';

import EventNotes from './EventNotes';
import Fact from './Fact';
const addOnLabel = (id: string) => PRIVATE_EVENT_ADD_ONS.find((a) => a.id === id)?.label ?? id;

export default function AddOnsNotesView({ event }: { event: PrivateEventCrewView }) {
  const { isPhone } = useViewport();
  return (
    <div style={{ display: 'grid', gridTemplateColumns: isPhone ? '1fr' : '1fr 1.3fr', gap: 14 }}>
      <Fact label={`Add-ons (${event.addOns.length})`}>
        {event.addOns.length === 0 ? (
          <span style={{ fontSize: 12, color: 'var(--nb-subtle)' }}>None</span>
        ) : (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5 }}>
            {event.addOns.map((id) => (
              <span
                key={id}
                style={{
                  fontSize: 11,
                  fontWeight: 600,
                  color: 'var(--nb-ink-2)',
                  background: 'var(--nb-surface-2)',
                  padding: '3px 9px',
                  borderRadius: 999,
                }}
              >
                {addOnLabel(id)}
              </span>
            ))}
          </div>
        )}
      </Fact>
      <Fact label="Internal notes">
        <EventNotes event={event} />
      </Fact>
    </div>
  );
}
